var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth"},[_c('the-login-form',{staticClass:"login-form",attrs:{"appName":"WebData","status":_vm.statusSignIn,"defaultUserName":_vm.userName},on:{"onSignIn":_vm.onSignIn}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }